import {
  createFileRoute,
  linkOptions,
  redirect,
} from '@tanstack/react-router';

const omniRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/omni/requests',
  from: '/mydigitalworkers/omni',
});

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/',
)({
  beforeLoad: () => {
    throw redirect(omniRequestLinkOptions);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <></>;
}
